<template lang="pug">
  div
    .visual-title.-xs.-white(:style="`background-image: url(https://cdn.taberutokurasuto.com/image/shop/item/list/gift.jpg);`")
      .title
        i.h1rem
          LogoYaneSvg
        h1.heading2 ギフト対応商品
        .heading3.curve-bottom Gift Present
    .archives-description
      p 贈り物に対応した商品のご紹介。気軽に贈れるプチギフトから贈答品、お祝いやお返し、季節の贈り物やプレゼントなどに、のし・ラッピング・メッセージカードをご注文と一緒に設定できる商品です。
      p.small ＊ギフトご対応内容はショップによって異なります。詳細は各ショップまでお問い合わせください。

    ItemFilterBlock
      DropDown(@change="$_changeOrder" v-model="pageInfo.orderBy" :options="$_orderDropDownOptions")
      .stock-checkbok
        FormCheckbox(@change="$_changeStockFilter" v-model="stockOnly") 販売中のみ表示

    ItemCardList
      .item.lg(v-for="(itemGroup, index) in itemGroups" :key="itemGroup.id")
        ItemCard(:itemGroup="itemGroup" eventCategory="商品一覧"  pageContents="商品一覧")
    .row
      .col-xs-12(v-if="itemGroups.length === 0")
        .success-notice
          .text-center 商品がありません。
      .col-xs-12
        Pager(@change="$_changePage" :custom-page-info="$_customPageInfo")

    SectionItemArchive
</template>

<script>
  import {GetItemGroupsForApi} from "../../graphqls/ItemGroups";

  import LogoYaneSvg from "../../components/svg/LogoYaneSvg";
  import ItemList from "../../components/list/ItemList";
  import GlobalMixin from "../../mixin/GlobalMixin";
  import Pager from "../../components/paginate/Pager";
  import DropDown from "../../components/v1/dropdown/DropDown";
  import ItemListMixin from "../../mixin/ItemListMixin";
  import ItemCard from "../../components/v1/item/ItemCardForApi";
  import ItemCardList from "../../components/v1/item/ItemCardList";
  import SectionItemArchive from "../../components/v1/section/SectionItemArchive";
  import FormCheckbox from "../../components/v1/form/FormCheckbox";
  import ItemFilterBlock from "../../components/v1/item/ItemFilterBlock";

  export default {
    name: "gift-items-index",
    mixins: [GlobalMixin, ItemListMixin],
    components: {
      ItemFilterBlock,
      FormCheckbox,
      SectionItemArchive,
      ItemCardList,
      DropDown,
      Pager,
      ItemList,
      ItemCard,
      LogoYaneSvg
    },
    props: [],
    data() {
      return {
        itemGroups: [],
        pageInfo: {
          currentPage:  Number(this.$route.params.page || 1),
          totalCount: 0,
          perPage: 48,
          orderBy: this.$route.query.order || 'popular'
        },
        stockOnly: this.$route.query?.stock === 'instock',
        withinYearItem: this.$route.query.wiy === 'true',
        firstItemGroup: {ogpImageUrl: ''}
      }
    },
    computed: {
      topRouterName() {
        return 'gift-items-index'
      },
      pageRouterName() {
        return 'gift-items-page-index'
      },
      stockFilter() {
        return this.stockOnly ? 'instock' : 'outstock'
      }
    },
    mounted() {
      this.fetchItemGroups()
    },
    methods: {
      async fetchItemGroups() {
        this.loadingStart();
        const { data } = await this.$apollo
        .query({
          query: GetItemGroupsForApi,
          variables: {
            giftItem: true,
            stockFilter: this.stockFilter,
            withinYearItem: this.withinYearItem,
            ...this.pageInfo
          },
          client: 'apiClient'
        })
        .catch(error => {
          this.loadingStop()
          return;
        });
        this.itemGroups = data.itemGroups.items;
        this.pageInfo = data.itemGroups.pageInfo
        this.loadingStop();
        this.$_gaSendViewItemList(this.itemGroups, 'shops/items/gift', this.pageInfo)
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
